var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaintOption24 = function SvgPaintOption24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62 2.006h2.77c.692 0 1.356.256 1.846.711.489.455.764 1.073.764 1.716V18.28c0 .987-.421 1.933-1.172 2.63A4.158 4.158 0 0 1 6 22a4.158 4.158 0 0 1-2.828-1.09C2.422 20.213 2 19.267 2 18.28V4.424c0-.643.275-1.26.763-1.714A2.71 2.71 0 0 1 4.607 2l.013.006Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15 13 3.58-.945a2.44 2.44 0 0 1 1.772.292 2.26 2.26 0 0 1 1.04 1.405l.549 2.329a2.151 2.151 0 0 1-.302 1.697c-.165.25-.38.467-.632.637a2.41 2.41 0 0 1-.838.357L8 21.5M2 6h8m-8 4h8m-8 4h8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m10.05 7.824 1.654-1.996a2.482 2.482 0 0 1 1.638-.817c.64-.059 1.28.122 1.777.504l1.993 1.529c.498.381.813.932.876 1.53a2.17 2.17 0 0 1-.537 1.661L9 21",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
export default SvgPaintOption24;